import React from "react"
import { Box, Chip, Typography, List, ListItem } from "@mui/joy"
import { Tag } from "../Snippet"
import { Anchor } from "../Typography"
import { useTranslation } from 'react-i18next'
import { useFormatter } from "src/mtska-frontend-app-component/utils"
import CampaignAvatar from "../Snippet/CampaignAvatar"
import JSONPretty from 'react-json-pretty'
const InfoHeaderCampaign = ({ item }) => {
    const { t } = useTranslation();
    const { formatDate } = useFormatter();

    return (
        item?.updated_at ?
            <Box
                className="info-header info-header-campaign"
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderRadius: 'lg',
                    bgcolor: '#FFFFFF'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <CampaignAvatar name={item?.name} url={item?.icon} item={item} />
                    <Box sx={{ flex: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                            <Chip color="primary" variant="soft">{t(item?.type) || '-'}</Chip>
                            <Chip color="secondary" variant="soft">{t(item?.mode) || '-'}</Chip>
                        </Box>

                        <Typography level="h2" sx={{ mb: 1.5, mt: 1, color: "var(--customer-800)" }}>
                            {item?.name}
                        </Typography>

                        <List
                            orientation="horizontal"
                            sx={{ gap: 2, m: 0, mb: 1, alignItems: 'center' }}
                        >
                            {
                                item?.email && (
                                    <ListItem sx={{ p: 0 }}>
                                        <Anchor icon="faEnvelope" iconfamily="fal" href={`mailto:${item?.email}`}>
                                            {item?.email}
                                        </Anchor>
                                    </ListItem>
                                )
                            }
                            {
                                item?.telephone && (
                                    <ListItem sx={{ p: 0 }}>
                                        <Anchor icon="faPhone" iconfamily="fal" href={`tel:${item?.telephone || ''}`}>
                                            {item?.telephone}
                                        </Anchor>
                                    </ListItem>
                                )
                            }
                            {
                                item?.mobile && (
                                    <ListItem sx={{ p: 0 }}>
                                        <Anchor icon="faPhone" iconfamily="fal" href={`tel:${item?.mobile || ''}`}>
                                            {item?.mobile}
                                        </Anchor>
                                    </ListItem>
                                )
                            }
                        </List>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            {item?.selectedSegments?.length
                                ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                                        {
                                            item.selectedSegments.map((seg, i) => (
                                                <Chip key={i} color="neutral" variant="soft" sx={{ flex: 1, backgroundColor: seg.color + '80' ?? '#00000005' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: seg.color ?? '#00000020' }} />
                                                        {seg.name}
                                                    </Box>
                                                </Chip>
                                            ))
                                        }
                                    </Box>
                                )
                                : <Chip color="warning" variant="soft">{t('No segment')}</Chip>
                            }

                            {item?.campaignLeads?.length
                                ? <Chip color="neutra" variant="soft">{t('{{count}} leads included', { count: item?.campaignLeads?.length })}</Chip>
                                : <Chip color="warning" variant="soft">{t('No assigned leads')}</Chip>
                            }
                        </Box>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        gap: 2,
                        minWidth: 120
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <Typography sx={{ textAlign: 'right', fontSize: '0.75rem' }}>{t('editingstatus')}</Typography>
                        <Tag color={item?.editingstatus == "campaign_new" ? "warning" : item?.editingstatus == "campaign_draft" ? "secondary" :"success"} dot label={t(item?.editingstatus)} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <Typography sx={{ textAlign: 'right', fontSize: '0.75rem' }}>{t('temporalState')}</Typography>
                        <Tag color={item?.temporalState == "not_executable" ? "neutral" : item?.temporalState == "future" ? "secondary" :"success"} dot label={t(item?.temporalState)} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <Typography sx={{ textAlign: 'right', fontSize: '0.75rem' }}>{t('start_at')}</Typography>
                        <Tag color="success" dot label={formatDate(item?.start_at)} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <Typography sx={{ textAlign: 'right', fontSize: '0.75rem' }}>{t('end_at')}</Typography>
                        <Tag color="success" dot label={formatDate(item?.end_at)} />
                    </Box>
                </Box>
            </Box>
            
            :
            <Box
                className="info-header info-header-person"
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderRadius: 'lg',
                    bgcolor: '#FFFFFF'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography level="h2" sx={{ mb: 1.5, mt: 1, color: "var(--neutral-400)", fontWeight:'200' }}>
                            {t('New campaign')}
                        </Typography>
                    </Box>
                </Box>
            </Box>

    )


}

export default InfoHeaderCampaign
